export enum SweetBombSoundType {
  YummyFgBgm = 'YummyFgBgm',
  HeavenlyFgBgm = 'HeavenlyFgBgm',

  MultiplierSuckAway = 'MultiplierSuckAway',
  Stop = 'Stop',
  StopTurbo = 'StopTurbo',
  BombExplode = 'BombExplode',
  AddMultiplier = 'AddMultiplier',
  CandyMachine = 'CandyMachine',
  MultiTumbleAdd = 'MultiTumbleAdd',
  MultiTumbleAdd2 = 'MultiTumbleAdd2',
  SymEliminate = 'SymEliminate',
  SymScatter1 = 'SymScatter1',
  SymScatter2 = 'SymScatter2',
  ScatterPeek = 'ScatterPeek',
  Scatter1Trigger = 'Scatter1Trigger',
  Scatter2Trigger = 'Scatter2Trigger',
  ButtonBuy = 'ButtonBuy',
  Boost = 'Boost',
  AddFgSpins = 'AddFgSpins',
  Fg1Cutscene = 'Fg1Cutscene',
  Fg2Cutscene = 'Fg2Cutscene',
  FgTotalWin = 'FgTotalWin',
}
